<!--
  横断図画面
-->
<template>
  <div
    class="kwb-com-cross container-col"
    :width="graphStageWidth"
    :height="graphStageHeight"
  >
    <div
      id="center"
      ref="center"
      class="graph-cross"
      :class="{ 'horizontal-scrollbar': scrollMode }"
      :width="windowWidth"
      :height="windowHeight"
      v-html="this.svgData"
    ></div>
  </div>
</template>

<script>
import crossSvg from "../../lib/CrossSvg.js";
export default {
  name: "kwb-com-cross",
  data() {
    return {
      historyValue: 0,
      svgData: "",
      drawCross: null,
    };
  },
  props: {
    // 実際の表示幅
    windowWidth: { default: 1200 },
    // 実際の表示高さ
    windowHeight: { default: 800 },
    // スクロールバー表示モード（true=拡大, false=全体）
    scrollMode: { type: Boolean, default: false },
    // 凡例表示モード（true=表示, false=非表示）
    showLegend: {
      type: Boolean,
      default: false,
    },
    // 詳細表示モード
    detailMode: { type: Boolean, default: false },
    // ポップアップ表示モード
    popupMode: { type: Boolean, default: false },
    // 観測値一覧表示モード
    listMode: { type: Boolean, default: false },
    // 横断図描画情報
    crossData: null,
    // スライダーのインデックス
    sliderIdx: { default: 0 },
  },
  watch: {
    windowWidth: function() {
      // リサイズ時にSVGを再描画
      this.setCrossSvg();
    },
    windowHeight: function() {
      // リサイズ時にSVGを再描画
      this.setCrossSvg();
    },
    showLegend: function(val) {
      // 凡例の表示・非表示を制御
      this.handleLegend(val);
    },
    scrollMode: function() {
      // スクロールモード変更時はSVGを再描画
      this.setCrossSvg();
    },
    crossData: function() {
      // 横断図のデータが変更時はSVGを再描画
      this.setCrossSvg();
    },
    sliderIdx: function() {
      // 水位のインデックス変更時
      this.handleChangeIdx();
    },
  },
  computed: {
    // 外枠のdivの表示幅
    graphStageWidth() {
      return this.windowWidth + "px";
    },
    // 外枠のdivの表示高さ
    graphStageHeight() {
      return this.windowHeight + "px";
    },
    history: {
      get() {
        return this.historyValue;
      },
      set(value) {
        if (
          value >=
          this.crossData.stages.length + this.crossData.stagesPrediction.length
        ) {
          this.historyValue =
            this.crossData.stages.length +
            this.crossData.stagesPrediction.length -
            1;
        } else {
          this.historyValue = value;
        }
      },
    },
  },
  mounted() {
    if (
      typeof this.crossData.drawType === "undefined" ||
      this.crossData.drawType === 0
    ) {
      return;
    }
    // SVGを生成
    this.setCrossSvg();
    var obj = this.$refs.center;
    // var obj = document.getElementById("center");
    if (obj) {
      // スクロールイベントリスナ登録
      obj.addEventListener("scroll", this.handleScroll);
    }
    // エラー情報格納
    var elmSvg = this.$refs.center.children["svg_cross"];
    this.$nextTick(() => {
      if (
        elmSvg != undefined &&
        elmSvg.children["g_cross"] != undefined &&
        elmSvg.children["g_scale"] != undefined
      ) {
        this.$store.commit("Swin/setSwCrossSvgError", false);
      } else {
        this.$store.commit("Swin/setSwCrossSvgError", true);
      }
    });
  },
  updated() {
    // スクロールバー初期表示位置
    this.defaultScroll();
    // エラー情報格納
    var elmSvg = this.$refs.center.children["svg_cross"];
    this.$nextTick(() => {
      if (
        elmSvg != undefined &&
        elmSvg.children["g_cross"] != undefined &&
        elmSvg.children["g_scale"] != undefined
      ) {
        this.$store.commit("Swin/setSwCrossSvgError", false);
      } else {
        this.$store.commit("Swin/setSwCrossSvgError", true);
        this.$log.debug(
          "[TmCross]" + this.$store.state.app.config.messageConfig.svgErrCslMsg
        );
      }
    });
  },
  beforeDestroy() {
    var obj = this.$refs.center;
    // var obj = document.getElementById("center");
    if (obj !== null) {
      // スクロールイベントリスナ破棄
      obj.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    setCrossSvg() {
      var setting = {
        windowWidth: this.windowWidth,
        windowHeight: this.windowHeight,
        scrollMode: this.scrollMode,
        showLegend: this.showLegend,
        detailMode: this.detailMode,
        markerMode: true,
        legendDivisionMode: false,
      };

      this.drawCross = new crossSvg.DrawCross(
        setting,
        this.crossData,
        this.sliderIdx
      );

      var svg = this.drawCross.svg();
      this.svgData = svg.outerHTML;
    },
    // スクロールイベント
    handleScroll() {
      var obj = this.$refs.center;
      if (obj !== null) {
        var elmSvg = this.$refs.center.children["svg_cross"];
        this.drawCross.changeScroll(obj.scrollLeft, elmSvg);
      }
    },
    // 初期スクロールイベント
    defaultScroll() {
      var obj = this.$refs.center;
      if (obj !== null) {
        var scrollWidth = obj.scrollWidth;
        var clientWidth = obj.clientWidth;
        var disTotal = this.crossData.totalDistance * 1000;
        var disP = this.crossData.presentDistance * 1000;
        var disAB = disTotal - disP;
        var disCenter = disAB / 2;

        var dis1px = disTotal / scrollWidth;
        var px1m = scrollWidth / disTotal;
        var disClientWidth = clientWidth * dis1px;

        if (this.crossData.dispP == 1) {
          // 登録地点がA点側にある場合
          obj.scrollLeft = (disCenter - disClientWidth / 2 + disP) * px1m;
        } else {
          // // 登録地点がB点側にある場合、登録地点が存在しない場合
          obj.scrollLeft = (disCenter - disClientWidth / 2) * px1m;
        }
        var elmSvg = this.$refs.center.children["svg_cross"];
        this.drawCross.changeScroll(obj.scrollLeft, elmSvg);
      }
    },
    // 凡例クリックイベント
    handleLegend(isShow) {
      var elmSvg = this.$refs.center.children["svg_cross"];
      this.drawCross.changeLegend(isShow, elmSvg);
    },
    // 水位インデックス変更イベント
    handleChangeIdx() {
      var elmSvg = this.$refs.center.children["svg_cross"];
      if (elmSvg) {
        this.drawCross.changeStageIdx(this.sliderIdx, elmSvg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/kwb.scss";
@import "../../scss/_media_query.scss";

.kwb-com-cross {
  background-color: #f9f9f9;
}

.horizontal-scrollbar {
  overflow-y: hidden;
  overflow-x: scroll;
}

/** 描画エリア用横スクロール */
.horizontal-scrollbar::-webkit-scrollbar {
  height: 14px;
}

/** 描画エリア用横スクロール */
.horizontal-scrollbar::-webkit-scrollbar-track {
  border-radius: 3px;
  background: #f0f0f0;
}

.horizontal-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: #cdcdcd;
}

.box-range {
  // スライダー
  width: 100%;
  height: 15px;
  padding-top: 0px;
  padding-top: 10px;
  .range-bk-1 {
    z-index: 4000;
    position: absolute;
    right: 178px;
    height: 18px;
    width: 351px;
    margin-top: -7px;
    background-color: #bdc6e4;
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px;
  }
  .range-bk-2 {
    z-index: 4000;
    position: absolute;
    right: 28px;
    height: 18px;
    width: 154px;
    margin-top: -7px;
    background-color: pink;
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
  }
  .range {
    position: absolute;
    z-index: 5000;
    // ブラウザ毎の外観をカット
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    // 外観設定
    // padding-top: 4px;
    width: 500px;
    height: 0px;
    background-color: #4169e1;
    border: 1px solid transparent;
    border-radius: 5px;
    cursor: pointer;
    outline: 0;
    // BOXSIZEの指定を変更
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    // スライダーの「つまみ」
    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background: #4169e1;
      border-radius: 3px;
      cursor: pointer;
      height: 20px;
      margin-top: -5px;
      width: 14px;
    }
    // スライダーの「つまみ」がアクティブ時
    &:active::-webkit-slider-thumb {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background-color: #da3722;
      cursor: pointer;
      position: relative;
    }
  }
}

.box-range-detail {
  // スライダー
  width: 100%;
  height: 15px;
  padding-top: 0px;
  padding-top: 10px;
  .range-bk-1 {
    z-index: 4000;
    position: absolute;
    right: calc(40vw);
    height: 18px;
    // width: 351px;
    width: calc(59.2vw);
    margin-top: -7px;
    background-color: #bdc6e4;
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px;
  }
  .range-bk-2 {
    z-index: 4000;
    position: absolute;
    right: 220px;
    height: 18px;
    width: calc(24.4vw);
    margin-top: -7px;
    background-color: pink;
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
  }
  .range {
    position: absolute;
    z-index: 5000;
    // ブラウザ毎の外観をカット
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    // 外観設定
    // padding-top: 4px;
    width: calc(100vw - 230px);
    margin-left: 4px;
    height: 0px;
    background-color: #4169e1;
    border: 1px solid transparent;
    border-radius: 5px;
    cursor: pointer;
    outline: 0;
    // BOXSIZEの指定を変更
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    // スライダーの「つまみ」
    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background: #4169e1;
      border-radius: 3px;
      cursor: pointer;
      height: 20px;
      margin-top: -5px;
      width: 14px;
    }
    // スライダーの「つまみ」がアクティブ時
    &:active::-webkit-slider-thumb {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background-color: #da3722;
      cursor: pointer;
      position: relative;
    }
  }
}

.box-range-popup {
  // スライダー
  width: 100%;
  height: 15px;
  padding-top: 0px;
  padding-top: 10px;
  .range-bk-1 {
    z-index: 4000;
    position: absolute;
    right: 156px;
    height: 18px;
    // width: 351px;
    width: 80%;
    margin-top: -7px;
    background-color: #bdc6e4;
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px;
  }
  .range-bk-2 {
    z-index: 4000;
    position: absolute;
    right: 12px;
    height: 18px;
    width: 29%;
    margin-top: -7px;
    background-color: pink;
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
  }
  .range {
    position: absolute;
    z-index: 5000;
    // ブラウザ毎の外観をカット
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    // 外観設定
    // padding-top: 4px;
    width: 98%;
    margin-left: 4px;
    height: 0px;
    background-color: #4169e1;
    border: 1px solid transparent;
    border-radius: 5px;
    cursor: pointer;
    outline: 0;
    // BOXSIZEの指定を変更
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    // スライダーの「つまみ」
    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background: #4169e1;
      border-radius: 3px;
      cursor: pointer;
      height: 20px;
      margin-top: -5px;
      width: 14px;
    }
    // スライダーの「つまみ」がアクティブ時
    &:active::-webkit-slider-thumb {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background-color: #da3722;
      cursor: pointer;
      position: relative;
    }
  }
}
</style>
